<template>
    <div class="skeleton-loader w-full h-full" data-testid="skeleton-loader">
        <slot />
    </div>
</template>

<script setup lang="ts">

</script>

<style lang="scss">
$speedAnimation: 2s;
.skeleton-loader {
    position: relative;
    overflow: hidden;
    .skeleton-item-block {
         background-color: var(--skeleton-loader);
        //background: linear-gradient(90deg, var(--colorWidgetBackground-color ) 25%, rgba(0, 0, 0, 0.1) 37%, var(--colorWidgetBackground-color ) 63%);
        //background-size: 400% 100%;
    }
    &:before {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 50%;
        width: 500%;
        margin-left: -250%;
        background: linear-gradient(98deg, transparent 46%, var(--skeleton-loader-animation) 50%, transparent 54%) 50% 50%;
        animation: skeletonAnimation $speedAnimation linear infinite;
        content: " ";
        pointer-events: none;
    }
}
[dir='rtl'] {
    .skeleton-loader {
        &:before {
            left: auto;
            margin-left: 0;
            right: 50%;
            margin-right: -250%;
        }
    }
}

@keyframes skeletonAnimation {
    0% {
        transform: translate3d(-30%, 0, 0);
    }

    100% {
        transform: translate3d(30%, 0, 0);
    }
}
</style>
